import mianqian from '@/pages/qiwei/mianqian.vue';
import checkin from '@/pages/qiwei/checkin.vue';
import interviewinglog from '@/pages/qiwei/interviewinglog.vue';
import interviewinginfo from '@/pages/qiwei/interviewinginfo.vue';
// import qiwei from '../../api/qiwei';

// 可乐收售后 打卡
import clsmianqian from '@/pages/qiwei/keleshou/mianqian.vue';
import clscheckin from '@/pages/qiwei/keleshou/checkin.vue';
import clsinterviewinglog from '@/pages/qiwei/keleshou/interviewinglog.vue';
import clsinterviewinginfo from '@/pages/qiwei/keleshou/interviewinginfo.vue';
import valuelease from '@/pages/qiwei/valuelease/index.vue';


const qiwei = [{
        path: '/qiwei/mianqian',
        // redirect: '/qiwei/mianqian',
        name: 'mianqian',
        component: mianqian,
        meta: {
            title: '客户面访'
        }
    },
    {
        path: '/qiwei/checkin',
        name: 'checkin',
        component: checkin,
        meta: {
            title: '面访签到'
        }
    },
    {
        path: '/qiwei/interviewinglog',
        name: 'interviewinglog',
        component: interviewinglog,
        meta: {
            title: '面访记录'
        }
    },
    {
        path: '/qiwei/interviewinginfo',
        name: 'interviewinginfo',
        component: interviewinginfo,
        meta: {
            title: '面访详情'
        }
    },
    // 科乐收售后 打卡
    {
        path: '/qiwei/keleshou/mianqian',
        name: 'clsmianqian',
        component: clsmianqian,
        meta: {
            title: 'CLS客户面访'
        }
    },
    {
        path: '/qiwei/keleshou/checkin',
        name: 'clscheckin',
        component: clscheckin,
        meta: {
            title: 'CLS面访签到'
        }
    },
    {
        path: '/qiwei/keleshou/interviewinglog',
        name: 'clsinterviewinglog',
        component: clsinterviewinglog,
        meta: {
            title: 'CLS面访记录'
        }
    },
    {
        path: '/qiwei/keleshou/interviewinginfo',
        name: 'clsinterviewinginfo',
        component: clsinterviewinginfo,
        meta: {
            title: 'CLS面访详情'
        }
    },
    {
        path: '/qiwei/valuelease',
        name: 'valuelease',
        component: valuelease,
        meta: {
            title: '租赁价值计算'
        }
    },
];


export default qiwei;


// WEBPACK FOOTER //
// ./src/router/modules/qiwei.js